var _defs, _g;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMidSplashPlaceholder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 308 560",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:#666;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "mid_splash_placeholder") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Top"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "180 157 115 222 115 240 133 240 198 175 198 157 180 157"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "127 200.89 127 169 158.89 169 170.89 157 115 157 115 212.89 127 200.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "186 196.11 186 228 154.11 228 142.11 240 198 240 198 184.11 186 196.11"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMidSplashPlaceholder);
export default __webpack_public_path__ + "static/media/mid_splash_placeholder.59441f411461edb9209d15107952636e.svg";
export { ForwardRef as ReactComponent };